import React from 'react'

import MobileLayout from '../../components/MobileLayout'
import ZydusHeader from '../../components/molecules/ZydusHeader'
import Text from '../../components/atoms/Text'

import CKDInfo from '../../assets/images/ckd-stats.webp'

const AboutPage = () => {
  return (
    <MobileLayout>
      <ZydusHeader />
      <div className="p-4 pt-24 lg:px-12 lg:pt-32 lg:pb-8 lg:max-w-3xl lg:mx-auto">
        <div className="flex flex-col gap-4">
          <Text variant="display" size="large" tag="p">
            What is CKD?
          </Text>
          <Text variant="body" size="large" className={'text-text-primary'}>
            Chronic Kidney Disease (CKD) is a progressive loss of kidney
            function over time. Your kidneys filter waste and excess fluids from
            your blood—when they don't work properly, toxins build up, leading
            to serious health complications.
          </Text>
        </div>

        <div className="mt-16 lg:mt-12 flex flex-col gap-4">
          <Text variant="display" size="large">
            How Common is CKD?
          </Text>
          <div className="flex justify-center">
            <img
              src={CKDInfo}
              className="w-full lg:max-w-sm lg:h-auto"
              alt="CKD statistics"
            />
          </div>
        </div>

        <div className="flex flex-col gap-4 mt-16 lg:mt-12">
          <Text variant="display" size="large">
            Why Early Detection Matters?
          </Text>
          <div className="flex flex-col">
            <Text variant="body" size="large">
              CKD often develops silently, with no noticeable symptoms until
              advanced stages. Early screening can help:
            </Text>
            <div className="mt-8 lg:mt-5 flex flex-col gap-1 text-text-primary">
              <Text variant="body" size="large">
                ✅ Slow down progression
              </Text>
              <Text variant="body" size="large">
                ✅ Prevent kidney failure
              </Text>
              <Text variant="body" size="large">
                ✅ Improve overall health
              </Text>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 mt-16 lg:mt-12">
          <Text variant="display" size="large">
            How to Take Charge?
          </Text>
          <div className="text-text-primary flex flex-col gap-3 mt-3 lg:mt-1">
            <Text
              variant="body"
              size="large"
              className={'relative'}
              tag={'div'}
            >
              <p>
                🩺 Book a Test – Regular screenings like eGFR, creatinine, and
                urine tests can detect kidney issues early.
              </p>
            </Text>
            <Text
              variant="body"
              size="large"
              className={'relative'}
              tag={'div'}
            >
              <p>
                🍽 Scan Your Food – Diet plays a crucial role in kidney health.
                Our PNDS Score helps you choose the right foods based on your
                health profile.
              </p>
            </Text>
          </div>
        </div>
      </div>
    </MobileLayout>
  )
}

export default AboutPage
